import ApiService from 'api-client/ApiService'
import config from 'app-config'

class Glu extends ApiService {
  public getClassName() {
    return 'glu'
  }

  protected async getEndpoint() {
    return Promise.resolve(config.apiHost)
  }

  get baseUrl(): string {
    return `/glu`
  }

  getRegionSummary = async (regionId: string) => {
    // return this.client.basicGet({
    //   url: `${this.baseUrl}/v1/summary/region/${regionId}`,
    //   options: {
    //     clsName: this.getClassName(),
    //     mthdName: 'getRegionSummary',
    //   },
    // })
    return {
      name: 'us-west-1',
      cpu: { unit: 'vCPU', capacity: 2400, allocated: 1680, utilization: 0.72 },
      memory: { unit: 'GiB', capacity: 9600, allocated: 5760, utilization: 0.68 },
      storage: { unit: 'GiB', capacity: 48000, allocated: 28800, utilization: 0.45 },
      instances: { unit: 'count', capacity: -1, allocated: 234, utilization: null },
      floating_ips: { unit: 'count', capacity: 256, allocated: 128, utilization: null },
      networks: { unit: 'count', capacity: -1, allocated: 45, utilization: null },
      routers: { unit: 'count', capacity: 50, allocated: 23, utilization: null },
      load_balancers: { unit: 'count', capacity: 32, allocated: 18, utilization: 0.55 },
      security_groups: { unit: 'count', capacity: 500, allocated: 156, utilization: null },
      hypervisors: { unit: 'count', capacity: 24, allocated: 24, utilization: 0.71 },
      metadata: {
        refreshed_at: '2025-08-22T13:30:00Z',
      },
    }
  }
}

export default Glu
